export const setFilters = (resetFilters, setFetchAll, setPageSize, setPagination, setQueryParams, options) => {
  setFetchAll(false);
  setPageSize(10);
  if (resetFilters) {
    if (Array.isArray(options)) {
      options.forEach((opt) => {
        if (Object.prototype.hasOwnProperty.call(opt, 'value')) {
          delete opt.value;
        }
      });
    }
    setPagination({
      page: 1,
      totalPages: 1,
      hasPreviousPage: false,
      hasNextPage: false,
      pageSize: 10,
    });
    setQueryParams({});
    return;
  }

  const keys = options.map((item) => item.name);
  const payload = keys.reduce(
    (acc, key, index) => ({ ...acc, [key]: options[index]?.value?.value ?? options[index]?.value }),
    {}
  );
  const markLabel = options?.find((item) => item.name === 'markId')?.value?.label;
  const modelLabel = options?.find((item) => item.name === 'modelId')?.value?.label;

  if (markLabel || modelLabel) {
    payload.markAndModel = [markLabel, modelLabel].filter(Boolean).join(' ');
  }

  setPagination({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: 10,
  });
  setQueryParams(payload);
};
